import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MDBBtn, MDBBtnGroup } from 'mdb-react-ui-kit';
import MusUtils from '../utils/Utilities';
import '../components/MusButton.css';

export default function HomePage() {

    const navigate = useNavigate();

    return (
        <div
        className='p-5 text-center bg-image'
        style={{ backgroundImage: "url('https://mdbootstrap.com/img/new/slides/041.webp')", minHeight: '400px', height: '80%' }}
        >
            <div className='mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
                <div className='d-flex justify-content-center align-items-center h-100'>
                    <div className='text-white'>
                        <h1 className='mb-3'>M U S y M A S</h1>
                        <h4 className='mb-3'>Gestor de Torneos de MUS</h4>
                        <h4 className='mb-3'>Version 1.0.4.2</h4>
                        <MDBBtn className={'musButton-md m-1'} onClick={()=>{navigate('/listadoTorneos')}}>
                            Entrar
                        </MDBBtn>
                        <br></br>
                        <br></br>
                        <br></br>
                        <div>
                            <MDBBtnGroup size='sm' >
                                <MDBBtn color='dark' onClick={()=>MusUtils.changeTheme('dark')} active>Oscuro</MDBBtn>
                                <MDBBtn color='light' onClick={()=>MusUtils.changeTheme('light')} active>Claro</MDBBtn>
                            </MDBBtnGroup>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
